import { forwardRef } from 'react';
import { isNotProduction } from '../../utilities/env.utils.js';
function renderWithRef(displayName, propTypes, renderFun) {
  const component = forwardRef(renderFun);
  component.displayName = "WithRef(".concat(displayName, ")");
  if (propTypes && isNotProduction()) {
    // Add propTypes only for non-production
    component.propTypes = propTypes;
  }
  return component;
}
export { renderWithRef };